import { useMutation } from "react-query";
import InternalStudyListService from "@services/internal-study-list-service";

export const useDeleteProcessMemberMutation = () => {
  return useMutation(InternalStudyListService.removeTrainessProcess);
};
